import { render, staticRenderFns } from "./EmailPopupButton.vue?vue&type=template&id=297749a0&"
import script from "./EmailPopupButton.vue?vue&type=script&lang=ts&"
export * from "./EmailPopupButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports